export enum MessageID {
  registerSuccess = 'REGISTER_SUCCESS',
  registerAlready = 'REGISTER_ALREADY',
}
